<template>
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3657_495)">
      <path
        d="M0.428572 5.42854L4.71429 1.14282L9 5.42854"
        stroke="#FF8A71"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3657_495">
        <rect
          width="5.71429"
          height="10"
          fill="white"
          transform="translate(10 0.142822) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
